import urls from "./init-config";

export const environment = urls.preUat;
